import { isNonEmptyArray } from '@/helpers/array-helpers'
import TimesheetsSummaryClientViewModel from './timesheetsSummaryClientViewModel'
import TimesheetsSummaryCandidateViewModel from './timesheetsSummaryCandidateViewModel'

export default class TimesheetsSummaryViewModel {
  constructor({
    clientTimesheetsSummary = [],
    candidateTimesheetsSummary = [],
    totalApprovedCount = 0,
    totalPendingReviewCount = 0,
    totalPendingApprovalCount = 0,
  } = {}) {
    /**
     * @type {Number}
     */
    this.totalApprovedCount = totalApprovedCount
    /**
     * @type {Number}
     */
    this.totalPendingReviewCount = totalPendingReviewCount
    /**
     * @type {Number}
     */
    this.totalPendingApprovalCount = totalPendingApprovalCount
    /**
     * @type {Array<TimesheetsSummaryClientViewModel>}
     */
    this.clientTimesheetsSummary = isNonEmptyArray(clientTimesheetsSummary)
      ? clientTimesheetsSummary.map(
          (client) => new TimesheetsSummaryClientViewModel(client)
        )
      : []
    /**
     * @type {Array<TimesheetsSummaryCandidateViewModel>}
     */
    this.candidateTimesheetsSummary = isNonEmptyArray(
      candidateTimesheetsSummary
    )
      ? candidateTimesheetsSummary.map(
          (candidate) => new TimesheetsSummaryCandidateViewModel(candidate)
        )
      : []
  }
}
